import kintFStorage from '~kint/firebase/storage.ts';

export async function uploadFileToStorage(
  path: string,
  file: Blob,
  onProgress: (progress: number, transferredBytes: number, totalBytes: number) => void
): Promise<string> {
  return kintFStorage.uploadFile(path, file, onProgress);
}
